import React from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';
import {DownlineProfile} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from '../TaskDetails.style';
import {TaskDetailsContent} from '../TaskDetailsContent';

export const JourneyKickOffCallDetails = () => {
  const {tt, ts} = useTranslation(
    'clientProfile.clientJourney.firstWeek.journeyKickOffCall',
  );

  return (
    <>
      <View style={styles.taskDetailContent}>
        {tt('details', () => (
          <Text
            variant="button"
            style={styles.taskDetailContentText}
            {...testProperties(DownlineProfile.cjTaskDetailsText)}>
            Ask your Client to watch the Journey Kickoff Video and take a look
            at the{' '}
            <Text variant="heading" style={styles.optaText}>
              OPTA
            </Text>
            VIA Guide. Then connect with them to answer any questions they may
            have.
          </Text>
        ))}
      </View>
      <View style={styles.taskDetailListHeading}>
        <Text
          variant="button"
          style={styles.taskDetailListHeading}
          {...testProperties(DownlineProfile.cjTaskDetailsBulletsHeaderText)}>
          {ts(
            'journeyKickoffCallDetailsListHeading',
            'Here are a few things to cover in your check-in the day before your Client starts:',
          )}
        </Text>
      </View>
      <TaskDetailsContent
        taskDetailsList={[
          ts(
            'detailsListItem1',
            'Motivate them by reviewing their goals from the Health Assessment.Encourage them to write down their why(s) in a highly visual place, like the bathroom mirror.',
          ),
          ts(
            'detailsListItem2',
            'Ask your Client to review the OPTAVIA Guide. Specifically, pages 14-21 that focus on the Optimal Weight 5 & 1 Plan®. If they’re on another Plan (for example, the Teen Plan, Nursing Mothers Plan, 4 & 2 & 1 Plan, etc.) then refer them to the appropriate Guide.',
          ),
          ts(
            'detailsListItem3',
            'Remind them to take a ‘Before’ photo as well as their measurements.',
          ),
          ts('detailsListItem4', 'Set up a check-in time for Day 1'),
        ]}
        style={{
          listItem: styles.journeyKickOffCallListItem,
        }}
      />
    </>
  );
};
